import { render, staticRenderFns } from "./statusCell.vue?vue&type=template&id=4509c671&scoped=true"
import script from "./statusCell.vue?vue&type=script&lang=js"
export * from "./statusCell.vue?vue&type=script&lang=js"
import style0 from "./statusCell.vue?vue&type=style&index=0&id=4509c671&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509c671",
  null
  
)

export default component.exports